import {
  FormControl,
  TextField,
  Button,
  Stack,
  Box,
  Grid,
  Paper,
  Card,
  CardHeader,
  Typography,
  MenuItem,
  Select,
  Snackbar,
  Alert,
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Switch,
  Chip,
  Menu,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import React, { useState, useEffect } from "react";
import { CircularProgress, Backdrop } from "@mui/material";
import {
  CheckCChasCondition,
  GetDetailsofCC,
  SelectCCbyId,
  GetLabelfromCC,
  UpdateCCProperties,
  DeleteCCbyId,
  DeleteCCProperties,
} from "../../../utilities/Wordutil";
import { TreeItem, TreeView } from "@mui/lab";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SaveIcon from "@mui/icons-material/Save";
import ColorDialog from "./ColorDialog";
import FormatColorFillSharpIcon from "@mui/icons-material/FormatColorFillSharp";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

/* global Word console */

const Controlpanel = () => {
  const [listvalues, setlistvalues] = useState([]);
  const [orglistvalues, setorglistvalues] = useState([]);
  const [isloading, setisloading] = useState(false);
  const [name, setname] = useState("");
  const [type, settype] = useState("");
  const [condvalue, setcondvalue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [popupopen, setpopupopen] = React.useState(false);
  const [message, setmessage] = React.useState("");
  const [dateformat, setdateformat] = React.useState("");
  const [numberformat, setnumberformat] = React.useState("");
  const [symbolvalue, setsymbolvalue] = React.useState("");
  const [treeviewflds, settreeviewflds] = useState([]);
  const [tabvalue, settabValue] = React.useState("1");
  const [switchChecked, setSwitchChecked] = useState(false);
  const [symbolChecked, setSymbolChecked] = useState(false);
  const [displayatpos, setdisplayatpos] = useState("");
  const [hdrcolor, sethdrcolor] = useState("None");
  const [hdrbold, sethdrbold] = useState("");
  const [datacolor, setdatacolor] = useState("None");
  const [bdrname, setbdrname] = useState("");
  const [bdrtype, setbdrtype] = useState("");
  const [bdrcolor, setbdrcolor] = useState("None");
  const [appliesto, setappliesto] = useState("");
  const [bdrwidth, setbdrwidth] = useState("");
  const [allowfit, setallowfit] = useState("");
  const [displayheader, setdisplayheader] = useState("");
  const [selectedid, setselectedid] = useState("");
  const [isSeltable, setisSeltable] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [opendata, setOpendata] = React.useState(false);
  const [openbdr, setOpenbdr] = React.useState(false);
  const [selcolor, setselcolor] = useState();
  const [selcolordata, setselcolordata] = useState();
  const [selcolorbdr, setselcolorbdr] = useState();
  const [autofield, setautofield] = useState("No");
  const [conditiontype, setconditiontype] = useState("");
  const [rowcondvalue, setrowcondvalue] = useState("");
  const [tablecondvalue, settablecondvalue] = useState("");

  const borderwidths = [{ value: 0.25 }, { value: 0.5 }, { value: 1 }, { value: 1.25 }, { value: 1.5 }, { value: 2 }];

  const bordernames = [
    { name: "All", value: Word.BorderLocation.all },
    { name: "Top", value: Word.BorderLocation.top },
    { name: "Left", value: Word.BorderLocation.left },
    { name: "Bottom", value: Word.BorderLocation.bottom },
    { name: "Right", value: Word.BorderLocation.right },
    { name: "InsideHorizontal", value: Word.BorderLocation.insideHorizontal },
    { name: "InsideVertical", value: Word.BorderLocation.insideVertical },
    { name: "Inside", value: Word.BorderLocation.inside },
    { name: "Outside", value: Word.BorderLocation.outside },
  ];

  const bordervalues = [
    { name: "None", value: Word.BorderType.none },
    { name: "Single", value: Word.BorderType.single },
    { name: "Double", value: Word.BorderType.double },
    { name: "Dotted", value: Word.BorderType.dotted },
    { name: "Dashed", value: Word.BorderType.dashed },
    { name: "DotDashed", value: Word.BorderType.dotDashed },
    { name: "Dot2Dashed", value: Word.BorderType.dot2Dashed },
    { name: "Triple", value: Word.BorderType.triple },
    { name: "ThinThickSmall", value: Word.BorderType.thinThickSmall },
    { name: "ThickThinSmall", value: Word.BorderType.thickThinSmall },
    { name: "ThinThickThinSmall", value: Word.BorderType.thinThickThinSmall },
    { name: "ThinThickMed", value: Word.BorderType.thinThickMed },
    { name: "ThickThinMed", value: Word.BorderType.thickThinMed },
    { name: "ThinThickThinMed", value: Word.BorderType.thinThickThinMed },
    { name: "ThinThickLarge", value: Word.BorderType.thinThickLarge },
    { name: "ThickThinLarge", value: Word.BorderType.thickThinLarge },
    { name: "ThinThickThinLarge", value: Word.BorderType.thinThickThinLarge },
    { name: "Wave", value: Word.BorderType.wave },
    { name: "DoubleWave", value: Word.BorderType.doubleWave },
    { name: "DashedSmall", value: Word.BorderType.dashedSmall },
    { name: "DashDotStroked", value: Word.BorderType.dashDotStroked },
    { name: "ThreeDEmboss", value: Word.BorderType.threeDEmboss },
    { name: "ThreeDEngrave", value: Word.BorderType.threeDEngrave },
    { name: "Mixed", value: Word.BorderType.mixed },
  ];

  function CleanEntitiesinValue(strtext: any) {
    strtext = strtext.replace("&gt;", ">");
    strtext = strtext.replace("&lt;", "<");
    return strtext;
  }

  const [contextMenu, setContextMenu] = React.useState(null);

  const handleContextMenu = (event) => {
    event.target.click();
    event.preventDefault();
    setContextMenu(
      contextMenu === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : null
    );
  };

  const handleDeleteCond = async () => {
    let setinRow = false;
    if (conditiontype === "Row") {
      setinRow = true;
    }
    await DeleteCCProperties(selectedid, setinRow);
    await getListvalues();
  };

  const handleDeleteClose = async () => {
    // Delete close
    setContextMenu(null);
    if (selectedid != null) {
      await DeleteCCbyId(selectedid);
      await getListvalues();
    }
  };

  const handleRefreshbutton = async () => {
    await getListvalues();
  };

  const handleRefreshClose = async () => {
    // Refresh menu
    setContextMenu(null);
    await getListvalues();
  };

  const handleMenuClose = () => {
    setContextMenu(null);
  };

  const handleresettable = () => {
    ResetTableOptions();
  };

  const handleClose = (newColor?: any) => {
    setOpen(false);
    if (newColor) {
      setselcolor(newColor);
      sethdrcolor(newColor.hex);
    }
  };

  const handleCloseData = (newColor?: any) => {
    setOpendata(false);
    if (newColor) {
      setselcolordata(newColor);
      setdatacolor(newColor.hex);
    }
  };

  const handleClosebdr = (newColor?: any) => {
    setOpenbdr(false);
    if (newColor) {
      setselcolorbdr(newColor);
      setbdrcolor(newColor.hex);
    }
  };

  const handleClickBdrButton = () => {
    setOpenbdr(true);
  };

  const handleClickButton = () => {
    setOpen(true);
  };

  const handleClickDataButton = () => {
    setOpendata(true);
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    settabValue(newValue);
  };

  const handlepopupClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setpopupopen(false);
  };

  function GetBorderbyName(strBdr: string) {
    let obj = bordernames.find((o) => o.name === strBdr);
    if (obj != null) {
      return obj.value;
    }
    return Word.BorderLocation.all;
  }

  function GetBorderbyType(strtype: string) {
    let obj = bordervalues.find((o) => o.name === strtype);
    if (obj != null) {
      return obj.value;
    }
    return Word.BorderType.none;
  }

  function findMatches(regex, str, matches = []) {
    const res = regex.exec(str);
    res && matches.push(res) && findMatches(regex, str, matches);
    return matches;
  }

  async function ApplyPropsviaOpenXML(headerclr, wholetbleclr, autofitmode) {
    await Word.run(async (context) => {
      if (headerclr === "None" || wholetbleclr === "None" || autofitmode === "Fit to contents") {
        let selrng1 = context.document.getSelection();
        // eslint-disable-next-line office-addins/no-navigational-load
        selrng1.load("parentTableOrNullObject");
        await context.sync();
        let selrng = selrng1.parentTableOrNullObject;
        if (selrng.isNullObject) {
          return;
        }
        selrng.select();
        let para = selrng.insertParagraph("", Word.InsertLocation.after);
        await context.sync();
        let tblrng = context.document.getSelection();
        let newRng = tblrng.expandTo(para.getRange("Whole"));
        await context.sync();
        let objxml = newRng.getOoxml();
        await context.sync();
        // eslint-disable-next-line office-addins/load-object-before-read
        let replxml = objxml.value;
        const matches = findMatches(/<w:tr\b[^>]*>(.*?)<\/w:tr>/g, replxml);
        console.log(headerclr + "-" + wholetbleclr + "-" + autofitmode);
        if (matches.length === 2) {
          if (wholetbleclr === "None" && headerclr === "None") {
            replxml = replxml.replace(/<w:shd [^>]*>/g, "");
          } else if (wholetbleclr === "None") {
            let trxml = matches[1][0];
            let orgtrxml = matches[1][0];
            trxml = trxml.replace(/<w:shd [^>]*>/g, "");
            replxml = replxml.replace(orgtrxml, trxml);
          } else if (headerclr === "None") {
            let trxml = matches[0][0];
            let orgtrxml = matches[0][0];
            trxml = trxml.replace(/<w:shd [^>]*>/g, "");
            replxml = replxml.replace(orgtrxml, trxml);
          }
          if (autofitmode === "Fit to contents") {
            replxml = replxml.replace(/<w:tblW [^>]*>/g, '<w:tblW w:w="0" w:type="auto"/>');
            replxml = replxml.replace(/<w:tcW [^>]*>/g, '<w:tcW w:w="0" w:type="auto"/>');
          }
          newRng.insertOoxml(replxml, "Replace");
          await context.sync();
          newRng.paragraphs.getLast().delete();
          await context.sync();
        }
      }
    });
  }

  const setConditionforCC = async () => {
    console.log("Tab value: ");
    console.log(tabvalue);
    if (tabvalue === "3") {
      //Do Table formattion here
      await Word.run(async (context) => {
        let selRange = context.document.getSelection();
        // eslint-disable-next-line office-addins/no-navigational-load
        selRange.load("parentTableOrNullObject");
        await context.sync();
        var Intable = selRange.parentTableOrNullObject;
        if (Intable.isNullObject) {
          console.log("exit");
          return;
        }
        console.log("Reading...");
        let tbl = selRange.parentTableOrNullObject;
        await context.sync();
        if (tbl.isNullObject === false) {
          console.log("Reading 1111 ...");
          console.log(hdrcolor);
          // Apply formatting to whole table
          if (datacolor != "None") {
            tbl.shadingColor = datacolor;
            await context.sync();
          }

          // Apply formatting to header row
          let hdrrow = tbl.rows.getFirstOrNullObject();
          await context.sync();
          if (hdrrow.isNullObject === false) {
            if (hdrcolor != "None") {
              hdrrow.shadingColor = hdrcolor;
              await context.sync();
            }
            if (hdrbold === "Bold") {
              hdrrow.font.bold = true;
            } else if (hdrbold === "Italic") {
              hdrrow.font.italic = true;
            } else if (hdrbold === "Bold Italic") {
              hdrrow.font.bold = true;
              hdrrow.font.italic = true;
            } else if (hdrbold === "Normal") {
              hdrrow.font.bold = false;
              hdrrow.font.italic = false;
            }
            await context.sync();
          }
          // Ends here

          // Apply borders
          if (bdrtype != "null" && bdrtype.length > 0) {
            let tblborder = tbl.getBorder(GetBorderbyName(bdrname));
            if (appliesto === "Header row") {
              tblborder = tbl.rows.getFirst().getBorder(GetBorderbyName(bdrname));
            }
            tblborder.load(["type", "width", "color"]);
            await context.sync();
            tblborder.type = GetBorderbyType(bdrtype);
            if (bdrtype != "None") {
              tblborder.color = bdrcolor;
              tblborder.width = parseFloat(bdrwidth);
            }
            await context.sync();
          }
          // Ends here

          if (allowfit === "Fit to window") {
            tbl.autoFitWindow();
            await context.sync();
          }
          console.log("Find...");
          console.log(hdrcolor);

          //Set display header
          if (selectedid != "") {
            let selnumber = Number(selectedid);
            let tablecc = context.document.contentControls.getById(selnumber);
            if (tablecc != null) {
              context.load(tablecc);
              await context.sync();
              if (tablecc.title === "Repeat") {
                let strtemp = displayheader;
                if (strtemp === "No") {
                  strtemp = "HeaderNo";
                } else if (strtemp === "" || strtemp === "Yes") {
                  strtemp = "HeaderYes";
                }
                tablecc.tag = strtemp;
                await context.sync();
              }
            }
          }
          //Ends here

          await ApplyPropsviaOpenXML(hdrcolor, datacolor, allowfit);
        }
      });
      //Ends here
    } else {
      let dateval = dateformat;
      let numbrval = numberformat;
      let updconditiontext = condvalue;
      let setinRow = false;
      let symbolval = symbolvalue;
      let displayval = displayatpos;
      if (conditiontype === "Row") {
        setinRow = true;
      }
      if (type != "date") {
        dateval = "";
      }
      if (type != "double" && type != "currency" && type != "percent") {
        numbrval = "";
      }
      var strsmartprops = "";
      if (tabvalue === "1") {
        if (autofield.length > 0) {
          strsmartprops = "<smartfield>" + autofield + "</smartfield>";
        }
      }
      var conlist = [{ fieldname: "", operatorval: "", resultval: "" }];
      if (tabvalue != "2") {
        updconditiontext = "";
      }
      console.log("Row in condition");
      console.log(setinRow);
      console.log(updconditiontext);
      console.log("Number format1...");
      console.log(numbrval);

      if (!symbolChecked) {
        symbolval = "";
      }

      UpdateCCProperties(
        conlist,
        selectedid,
        updconditiontext,
        dateval,
        setinRow,
        strsmartprops,
        numbrval,
        symbolval,
        displayval
      );
      if (tabvalue === "2") setmessage("Conditions marked for Content Control");
      else {
        setmessage("Properties updated for content control");
      }
      setpopupopen(true);
      await Word.run(async (context) => {
        context.document.save();
        await context.sync();
      });
      await getListvalues();
    }
  };

  async function GetHeaderDetailsfromTable(Hdrccid: any) {
    let strHeaderDetail = "Yes";
    await Word.run(async (context) => {
      console.log("SEL ID => ");
      console.log(Hdrccid);
      let selnumber = Number(Hdrccid);
      console.log(selnumber);
      let tablecc = context.document.contentControls.getByIdOrNullObject(selnumber);
      context.load(tablecc);
      await context.sync();
      let strtemp = tablecc.tag;
      console.log("strtemp=>");
      console.log(strtemp);
      if (strtemp === null || strtemp === "") {
        strHeaderDetail = "Yes";
      } else if (strtemp != null) {
        strHeaderDetail = strtemp.replace("Header", "");
      }
    });
    return strHeaderDetail;
  }

  async function getListvalues() {
    let selectionID = 0;
    const objlist = [];
    const tablectrls = [];
    settreeviewflds([]);
    setisloading(true);
    await Word.run(async (context) => {
      let contentctrls = context.document.contentControls;
      contentctrls.load("items");
      await context.sync();
      for (var i = 0; i < contentctrls.items.length; i++) {
        contentctrls.items[i].load(
          "appearance," +
            "cannotDelete," +
            "cannotEdit," +
            "color," +
            "id," +
            "placeHolderText," +
            "removeWhenEdited," +
            "title," +
            "text," +
            "type," +
            "style," +
            "tag," +
            "font/size," +
            "font/name," +
            "font/color"
        );
        let strtitle = contentctrls.items[i].title;
        let strId = contentctrls.items[i].id;
        if (strtitle === "Fields") {
          let blncheck = await CheckCChasCondition(strId);
          let fldlabel = await GetLabelfromCC(strId);
          let details = await GetDetailsofCC(strId);
          console.log("Details ...");
          console.log(details);
          if (details != null && !details.istable) {
            if (fldlabel.length == 0) {
              fldlabel = contentctrls.items[i].tag;
            }
            if (blncheck || (details.all != null && details.all.length > 0)) {
              objlist.push({
                id: strId,
                label: fldlabel,
                hascondition: blncheck,
                isopen: false,
                children: [
                  {
                    id: 0,
                    label: "Condition",
                  },
                ],
              });
            } else {
              objlist.push({
                id: strId,
                label: fldlabel,
                hascondition: blncheck,
                isopen: false,
                children: [],
              });
            }
          }
        } else if (strtitle == "Repeat") {
          contentctrls.items[i].load(
            "contentControls,contentControls/items,contentControls/items/title,contentControls/items/id"
          );
          objlist.push({
            id: strId,
            label: "Tables ()",
            hascondition: false,
            isopen: false,
            children: [],
          });
          tablectrls.push({ id: strId, controls: contentctrls.items[i] });
        } else if (strtitle == "Clauses") {
          objlist.push({
            id: strId,
            label: "Clauses (" + contentctrls.items[i].tag + ")",
            hascondition: true,
            isopen: false,
            children: [
              {
                id: 0,
                label: "Condition",
              },
            ],
          });
        }
      }
      await context.sync();
      if (tablectrls.length > 0) {
        for (i = 0; i < tablectrls.length; i++) {
          let sbtblctrls = [];
          for (var k = 0; k < tablectrls[i].controls.contentControls.items.length; k++) {
            var strId = tablectrls[i].controls.contentControls.items[k].id;
            let blncheck = await CheckCChasCondition(strId);
            let fldlabel = await GetLabelfromCC(strId);
            sbtblctrls.push({
              id: strId,
              label: fldlabel,
              hascondition: blncheck,
              isopen: false,
              children: [],
            });
          }
          var findtvitem = findValue(objlist, tablectrls[i].id);
          var details = await GetDetailsofCC(tablectrls[i].id);
          console.log("Details of table...");
          console.log(details);
          if (findtvitem != undefined) {
            findtvitem.children = sbtblctrls;
            if (details != null) {
              console.log("Selected details....");
              console.log(details);
              let strname = details.label;
              if (strname.indexOf(".") > 0) {
                strname = details.name.split(".")[details.name.split(".").length - 1];
              }
              findtvitem.label = "Table (" + strname + ")";
            }
          }
        }
      }
      // Get Selection ID from content control
      let getselparent = context.document.getSelection().contentControls.getFirstOrNullObject();
      if (getselparent != null) {
        context.load(getselparent);
        await context.sync();
        if (getselparent.title === "Fields") {
          selectionID = getselparent.id;
        }
      }
      if (selectionID === 0) {
        getselparent = context.document.getSelection().parentContentControlOrNullObject;
        context.load(getselparent);
        await context.sync();
        if (getselparent.title === "Fields") {
          selectionID = getselparent.id;
        }
      }
      // Ends here
    });
    console.log("Default ID...");
    if (objlist != null && objlist.length > 0) {
      if (selectionID != 0) {
        setselectedid(selectionID + "");
        RefreshSelection(selectionID);
      } else {
        setselectedid(objlist[0].id);
        RefreshSelection(objlist[0].id);
      }
    }
    settreeviewflds(objlist);
    setlistvalues(objlist);
    setorglistvalues(objlist);
    setisloading(false);
  }

  let findValue = (arr, val) => {
    for (let obj of arr) {
      if (obj.id === val) {
        return obj;
      }
      if (obj.children) {
        let result = findValue(obj.children, val);
        if (result) {
          return result;
        }
      }
    }
    return undefined;
  };

  function ResetTableOptions() {
    sethdrcolor("None");
    setdatacolor("None");
    sethdrbold("Normal");
    setappliesto("Whole table");
    setbdrname("All");
    setbdrtype("None");
    setbdrwidth("1");
    setbdrcolor("None");
    setallowfit("Fit to window");
  }

  async function RefreshSelection(nodeId: any) {
    var details = await GetDetailsofCC(nodeId);
    console.log("Seldetails node id...");
    console.log(nodeId);
    console.log("Seldetails...");
    console.log(details);
    settype("");
    if (details != null) {
      setname(details.name);
      settype(details.type);
      setautofield(details.smartfield.length === 0 ? "No" : details.smartfield);
      setcondvalue(details.all);
      // ** set row conditions
      setrowcondvalue(details.tablerowcondition);
      settablecondvalue(details.all);
      // ** ends here
      let strdateformat = details.dateformat;
      if (strdateformat === "") {
        strdateformat = "None";
      }
      setdateformat(strdateformat);
      let strnumbformat = details.numberformat;
      if (strnumbformat === "") {
        strnumbformat = "None";
      }
      setnumberformat(strnumbformat);

      let strsym = details.symbolstring;
      setsymbolvalue(strsym);
      if (strsym.length > 0) {
        setSymbolChecked(true);
      } else {
        setSymbolChecked(false);
      }

      let strdisplaysym = details.displaysymbol;
      if (strdisplaysym === "") {
        strdisplaysym = "None";
      }
      setdisplayatpos(strdisplaysym);

      if (details.istable) {
        setisSeltable(true);
      } else {
        setisSeltable(false);
      }
      ResetTableOptions();
    }
    SelectCCbyId(nodeId);
    setselectedid(nodeId);
    settabValue("1");
    if (details != null && details.istable) {
      console.log("Checking Header info....");
      let headerinfo = await GetHeaderDetailsfromTable(nodeId);
      console.log("headerinfo");
      console.log(headerinfo);
      setdisplayheader(headerinfo);
    }
    setconditiontype("Table");
  }

  const handleNodeSelect = async (_: any, nodeId: any) => {
    RefreshSelection(nodeId);
  };

  function SetConditionsBasedonType(strvalue) {
    if (strvalue === "Row") {
      setcondvalue(rowcondvalue);
    } else {
      setcondvalue(tablecondvalue);
    }
  }

  const treestyle = {
    "& .MuiTreeItem-label": {
      fontSize: "12.5px",
      padding: 0.25,
    },
  };

  const renderTree = (node: any) => (
    <TreeItem sx={treestyle} key={node.id} nodeId={node.id} label={node.label} onContextMenu={handleContextMenu}>
      {Array.isArray(node.children) && node.children.length
        ? node.children.map((subnode: any) => renderTree(subnode))
        : null}
    </TreeItem>
  );

  useEffect(() => {
    getListvalues();
  }, []);

  useEffect(() => {
    if (searchValue.length === 0) {
      settreeviewflds(orglistvalues);
    } else {
      const newlistvalues = listvalues.filter((value) => value.label.toLowerCase().includes(searchValue.toLowerCase()));
      settreeviewflds(newlistvalues);
    }
  }, [searchValue]);

  return (
    <Box sx={{ p: 2, marginTop: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl fullWidth size="small" sx={{ minWidth: 260, padding: 0 }}>
            <TextField
              name="searchfield"
              label="Search fields"
              size="small"
              variant="outlined"
              onChange={(e) => setSearchValue(e.target.value)}
              value={searchValue}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end" alignItems="flex-end">
            <Chip
              icon={<RestartAltIcon sx={{ height: "18px", width: "22px" }} />}
              label="Refresh"
              color="primary"
              onClick={handleRefreshbutton}
              sx={{ height: "22px" }}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ border: 1, borderColor: "lightgray", maxHeight: 300, overflow: "auto" }}>
            <TreeView
              aria-label="rich object"
              defaultCollapseIcon={<ExpandMore />}
              defaultExpandIcon={<ChevronRightIcon />}
              onNodeSelect={handleNodeSelect}
              selected={selectedid}
              sx={{
                position: "relative",
                height: "100vh",
                maxWidth: 500,
                overflowY: "auto",
                overflowX: "hidden",
              }}
            >
              {treeviewflds.map((node) => renderTree(node))}
            </TreeView>
            <Menu
              open={contextMenu !== null}
              onClose={handleMenuClose}
              anchorReference="anchorPosition"
              anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
            >
              <MenuItem onClick={handleDeleteClose}>Delete</MenuItem>
              <MenuItem onClick={handleRefreshClose}>Refresh Control manager</MenuItem>
            </Menu>
          </Paper>
        </Grid>
        <Grid item xs={12}>
          <Card variant="outlined">
            <CardHeader
              sx={{ padding: 0, margin: 0, backgroundColor: "#1C39BB" }}
              title={
                <Typography variant="body2" sx={{ color: "white", padding: 0.5, margin: 0 }}>
                  Properties
                </Typography>
              }
              action={
                <Button
                  disabled={selectedid.length === 0}
                  variant="outlined"
                  disableRipple={true}
                  size="small"
                  sx={{ border: 0, borderRadius: 0, bgcolor: "#1C39BB", color: "white", marginTop: 0.5 }}
                  startIcon={<SaveIcon sx={{ marginTop: 0.25, marginBottom: 0, marginLeft: 0, marginRight: 0 }} />}
                  onClick={setConditionforCC}
                />
              }
            >
              <Typography></Typography>
            </CardHeader>
            {selectedid != "" ? (
              <TabContext value={tabvalue}>
                <Box sx={{ borderBottom: 1, borderColor: "divider", padding: 0, margin: 0 }}>
                  <TabList
                    onChange={handleTabChange}
                    aria-label="Properties"
                    variant="standard"
                    sx={{ minHeight: "36px", height: "36px" }}
                  >
                    <Tab
                      label="General"
                      value="1"
                      sx={{ minHeight: "36px", height: "36px", textTransform: "none", fontFamily: "Arial" }}
                    />
                    {(condvalue.length > 0 || rowcondvalue.length > 0) && (
                      <Tab
                        label="Condition"
                        value="2"
                        sx={{ minHeight: "36px", height: "36px", textTransform: "none", fontFamily: "Arial" }}
                      />
                    )}
                    {isSeltable && (
                      <Tab
                        label="Table"
                        value="3"
                        sx={{ minHeight: "36px", height: "36px", textTransform: "none", fontFamily: "Arial" }}
                      />
                    )}
                  </TabList>
                </Box>
                <TabPanel value="1" sx={{ padding: 0 }}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell width="5%">Name: </TableCell>
                          <TableCell>{name}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell>Type: </TableCell>
                          <TableCell>{type}</TableCell>
                        </TableRow>
                        {!isSeltable && (
                          <TableRow>
                            <TableCell>Smart: </TableCell>
                            <TableCell>
                              <FormControl size="small" fullWidth>
                                <Select
                                  sx={{ fontSize: "10pt" }}
                                  id="demo-select-small"
                                  value={autofield}
                                  onChange={(e) => {
                                    setautofield(e.target.value + "");
                                  }}
                                >
                                  <MenuItem value="Yes">Yes</MenuItem>
                                  <MenuItem value="No">No</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                        )}
                        {(type === "double" || type === "currency" || type === "percent") && (
                          <TableRow>
                            <TableCell>Decimal: </TableCell>
                            <TableCell>
                              <FormControl size="small" fullWidth>
                                <Select
                                  sx={{ fontSize: "10pt" }}
                                  id="Num-select-small"
                                  value={numberformat}
                                  onChange={(e) => {
                                    setnumberformat(e.target.value + "");
                                  }}
                                >
                                  <MenuItem value="None">
                                    <em>None</em>
                                  </MenuItem>
                                  <MenuItem value="0">0</MenuItem>
                                  <MenuItem value="1">1</MenuItem>
                                  <MenuItem value="2">2</MenuItem>
                                  <MenuItem value="3">3</MenuItem>
                                  <MenuItem value="4">4</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                        )}
                        {(type === "currencyzzz" || type === "percentzzz") && (
                          <>
                            <TableRow>
                              <TableCell>
                                <Stack direction="row" justifyContent="space-around">
                                  <Typography sx={{ fontSize: "10.5pt" }}>Symbol: </Typography>
                                  <Switch
                                    size="small"
                                    color="primary"
                                    checked={symbolChecked}
                                    onChange={() => {
                                      setSymbolChecked(!symbolChecked);
                                    }}
                                  />
                                </Stack>
                              </TableCell>
                              <TableCell>
                                <FormControl size="small" fullWidth>
                                  <TextField
                                    disabled={!symbolChecked}
                                    id="standard-basic"
                                    label=""
                                    variant="standard"
                                    size="small"
                                    onChange={(e) => setsymbolvalue(e.target.value)}
                                    value={symbolvalue}
                                  />
                                </FormControl>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>Symbol at: </TableCell>
                              <TableCell>
                                <FormControl size="small" fullWidth>
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="select-small-display"
                                    value={displayatpos}
                                    onChange={(e) => {
                                      setdisplayatpos(e.target.value + "");
                                    }}
                                  >
                                    <MenuItem value="None">None</MenuItem>
                                    <MenuItem value="Header">Header</MenuItem>
                                    <MenuItem value="Body">Body</MenuItem>
                                    <MenuItem value="Both">Both</MenuItem>
                                  </Select>
                                </FormControl>
                              </TableCell>
                            </TableRow>
                          </>
                        )}
                        {type == "date" && (
                          <TableRow>
                            <TableCell>Format: </TableCell>
                            <TableCell>
                              <FormControl size="small" fullWidth>
                                <Select
                                  sx={{ fontSize: "10pt" }}
                                  id="demo-select-small"
                                  value={dateformat}
                                  onChange={(e) => {
                                    setdateformat(e.target.value + "");
                                  }}
                                >
                                  <MenuItem value="None">
                                    <em>None</em>
                                  </MenuItem>
                                  <MenuItem value="M/d/yy">M/d/yy</MenuItem>
                                  <MenuItem value="MM/dd/yy">MM/dd/yy</MenuItem>
                                  <MenuItem value="MM-dd-yy">MM-dd-yy</MenuItem>
                                  <MenuItem value="M-d-yy">M-d-yy</MenuItem>
                                  <MenuItem value="MMM d, yyyy">MMM d, yyyy</MenuItem>
                                  <MenuItem value="MMMM d, yyyy">MMMM d, yyyy</MenuItem>
                                  <MenuItem value="MMM d yyyy">MMM d yyyy</MenuItem>
                                  <MenuItem value="yyyy-MM-dd">yyyy-MM-dd</MenuItem>
                                  <MenuItem value="MM-dd-yyyy">MM-dd-yyyy</MenuItem>
                                  <MenuItem value="M-d-yyyy">M-d-yyyy</MenuItem>
                                  <MenuItem value="dd/MM/yyyy">dd/MM/yyyy</MenuItem>
                                  <MenuItem value="d/M/yyyy">d/M/yyyy</MenuItem>
                                  <MenuItem value="MM/dd/yyyy">MM/dd/yyyy</MenuItem>
                                  <MenuItem value="M/d/yyyy">M/d/yyyy</MenuItem>
                                  <MenuItem value="yyyy/M/d">yyyy/M/d</MenuItem>
                                  <MenuItem value="d/MMM/yyyy">d/MMM/yyyy</MenuItem>
                                  <MenuItem value="dd MMMM yyyy">dd MMMM yyyy</MenuItem>
                                  <MenuItem value="dd-MMM-yyyy">dd-MMM-yyyy</MenuItem>
                                  <MenuItem value="dd/MMM/yy">dd/MMM/yy</MenuItem>
                                  <MenuItem value="dd/MM/yy">dd/MM/yy</MenuItem>
                                  <MenuItem value="d-MMM-yyyy">d-MMM-yyyy</MenuItem>
                                  <MenuItem value="yy/MM/dd">yy/MM/dd</MenuItem>
                                  <MenuItem value="dd-mm-yyyy">dd-MM-yyyy</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value="2" sx={{ padding: 0 }}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableBody>
                        {isSeltable && (
                          <TableRow>
                            <TableCell sx={{ padding: 0.5 }} width="5%">
                              Type:{" "}
                            </TableCell>
                            <TableCell sx={{ padding: 0.5, textAlign: "left" }}>
                              <FormControl size="small" fullWidth>
                                <Select
                                  disabled={type==='Table'?false:true}
                                  sx={{ fontSize: "10pt" }}
                                  id="demo-select-small"
                                  value={conditiontype}
                                  onChange={(e) => {
                                    setconditiontype(e.target.value + "");
                                    SetConditionsBasedonType(e.target.value + "");
                                  }}
                                >
                                  <MenuItem value="Table">Table</MenuItem>
                                  <MenuItem value="Row">Row</MenuItem>
                                </Select>
                              </FormControl>
                            </TableCell>
                          </TableRow>
                        )}
                        <TableRow>
                          <TableCell sx={{ padding: 0.5 }}>Condition: </TableCell>
                          <TableCell sx={{ padding: 0.5 }}>{CleanEntitiesinValue(condvalue)}</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell colSpan={2} sx={{ padding: 0.5 }}>
                            <Stack sx={{ padding: 0 }}>
                              <Stack direction="row" justifyContent="space-between">
                                <Stack direction="row">
                                  <Typography sx={{ fontSize: "10.5pt" }}>Edit: </Typography>
                                  <Switch
                                    size="small"
                                    color="primary"
                                    checked={switchChecked}
                                    onChange={() => {
                                      setSwitchChecked(!switchChecked);
                                    }}
                                  />
                                </Stack>
                                <Chip
                                  icon={<RestartAltIcon sx={{ height: "18px", width: "22px" }} />}
                                  label="Delete"
                                  color="primary"
                                  onClick={handleDeleteCond}
                                  sx={{ height: "22px" }}
                                />
                              </Stack>
                              {switchChecked && (
                                <TextField
                                  id="txtcondition"
                                  value={CleanEntitiesinValue(condvalue)}
                                  onChange={(e) => {
                                    setcondvalue(e.target.value);
                                  }}
                                  multiline
                                  maxRows={4}
                                  inputProps={{ style: { fontSize: "0.75rem" } }}
                                />
                              )}
                            </Stack>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TabPanel>
                <TabPanel value="3" sx={{ padding: 0 }}>
                  <Table size="small" sx={{ padding: 0 }}>
                    <TableBody sx={{ padding: 0 }}>
                      <TableRow sx={{ padding: 0 }}>
                        <TableCell sx={{ padding: 1 }} align="right">
                          <Chip
                            icon={<RestartAltIcon sx={{ height: "18px", width: "18px" }} />}
                            label="Reset"
                            color="primary"
                            onClick={handleresettable}
                            sx={{ height: "22px" }}
                          />
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ padding: 0 }}>
                        <TableCell sx={{ padding: 1 }}>
                          <Box
                            component="fieldset"
                            sx={{ margin: 0, borderRadius: 1, border: 0.25, borderColor: "lightgrey" }}
                          >
                            <legend>
                              <Typography
                                sx={{
                                  fontSize: "9pt",
                                  fontWeight: "Bold",
                                  marginLeft: 0.5,
                                  marginRight: 0.5,
                                  margintop: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Header
                              </Typography>
                            </legend>
                            <Grid container sx={{ margin: 0 }}>
                              <Grid item xs={6}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Display header: </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={displayheader}
                                    onChange={(e) => setdisplayheader(e.target.value + "")}
                                  >
                                    <MenuItem key="Yes" value="Yes">
                                      Yes
                                    </MenuItem>
                                    <MenuItem key="No" value="No">
                                      No
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={6}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Backgound colour: </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Chip
                                  label={hdrcolor}
                                  onClick={handleClickButton}
                                  onDelete={handleClickButton}
                                  deleteIcon={<FormatColorFillSharpIcon />}
                                  variant="outlined"
                                  sx={{ color: `${hdrcolor}`, borderRadius: 0, border: 0 }}
                                />
                                <ColorDialog
                                  id="ringtone-menu"
                                  keepMounted
                                  open={open}
                                  onClose={handleClose}
                                  color={selcolor}
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Formatting: </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={hdrbold}
                                    onChange={(e) => sethdrbold(e.target.value + "")}
                                  >
                                    <MenuItem key="Normal" value="Normal">
                                      Normal
                                    </MenuItem>
                                    <MenuItem key="Bold" value="Bold">
                                      Bold
                                    </MenuItem>
                                    <MenuItem key="Italic" value="Italic">
                                      Italic
                                    </MenuItem>
                                    <MenuItem key="Bold Italic" value="Bold Italic">
                                      Bold Italic
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                            </Grid>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ padding: 0 }}>
                        <TableCell sx={{ padding: 1 }}>
                          <Box
                            component="fieldset"
                            sx={{ margin: 0, borderRadius: 1, border: 0.25, borderColor: "lightgrey" }}
                          >
                            <legend>
                              <Typography
                                sx={{
                                  fontSize: "9pt",
                                  fontWeight: "Bold",
                                  marginLeft: 0.5,
                                  marginRight: 0.5,
                                  margintop: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Data
                              </Typography>
                            </legend>
                            <Grid container sx={{ margin: 0 }}>
                              <Grid item xs={6}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Backgound colour: </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Chip
                                  label={datacolor}
                                  onClick={handleClickDataButton}
                                  onDelete={handleClickDataButton}
                                  deleteIcon={<FormatColorFillSharpIcon />}
                                  variant="outlined"
                                  sx={{ color: `${datacolor}`, borderRadius: 0, border: 0 }}
                                />
                                <ColorDialog
                                  id="ringtone-menu"
                                  keepMounted
                                  open={opendata}
                                  onClose={handleCloseData}
                                  color={selcolordata}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ padding: 0 }}>
                        <TableCell sx={{ padding: 1 }}>
                          <Box
                            component="fieldset"
                            sx={{ margin: 0, borderRadius: 1, border: 0.25, borderColor: "lightgrey" }}
                          >
                            <legend>
                              <Typography
                                sx={{
                                  fontSize: "9pt",
                                  fontWeight: "Bold",
                                  marginLeft: 0.5,
                                  marginRight: 0.5,
                                  margintop: 0,
                                  marginBottom: 0,
                                }}
                              >
                                Border
                              </Typography>
                            </legend>
                            <Grid container sx={{ margin: 0 }}>
                              <Grid item xs={4}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Apply: </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={appliesto}
                                    onChange={(e) => setappliesto(e.target.value + "")}
                                  >
                                    <MenuItem key="Whole table" value="Whole table">
                                      Whole table
                                    </MenuItem>
                                    <MenuItem key="Header row" value="Header row">
                                      Header row
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Border: </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={bdrname}
                                    onChange={(e) => setbdrname(e.target.value + "")}
                                  >
                                    {bordernames.map((element) => (
                                      <MenuItem key={element.name} value={element.name}>
                                        {element.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Type: </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={bdrtype}
                                    onChange={(e) => setbdrtype(e.target.value + "")}
                                  >
                                    {bordervalues.map((element) => (
                                      <MenuItem key={element.name} value={element.name}>
                                        {element.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Width: </Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                  <Select
                                    sx={{ fontSize: "10pt" }}
                                    id="demo-select-small"
                                    value={bdrwidth}
                                    onChange={(e) => setbdrwidth(e.target.value + "")}
                                  >
                                    {borderwidths.map((element) => (
                                      <MenuItem key={element.value.toString()} value={element.value.toString()}>
                                        {element.value.toString()}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Grid>
                              <Grid item xs={4}>
                                <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>colour: </Typography>
                              </Grid>
                              <Grid item xs={6}>
                                <Chip
                                  label={bdrcolor}
                                  onClick={handleClickBdrButton}
                                  onDelete={handleClickBdrButton}
                                  deleteIcon={<FormatColorFillSharpIcon />}
                                  variant="outlined"
                                  sx={{ color: `${bdrcolor}`, borderRadius: 0, border: 0 }}
                                />
                                <ColorDialog
                                  id="ringtone-menu"
                                  keepMounted
                                  open={openbdr}
                                  onClose={handleClosebdr}
                                  color={selcolorbdr}
                                />
                              </Grid>
                            </Grid>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={2} sx={{ padding: 0.5 }}>
                          <Stack
                            direction="row"
                            sx={{ marginLeft: 0.5, marginRight: 0.5, margintop: 0, marginBottom: 0 }}
                          >
                            <Grid item xs={6}>
                              <Typography sx={{ fontSize: "10pt", marginTop: 1 }}>Allow Auto Fit: </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <FormControl sx={{ m: 1, minWidth: 100 }} variant="standard" size="small">
                                <Select
                                  sx={{ fontSize: "10pt" }}
                                  id="demo-select-small"
                                  value={allowfit}
                                  onChange={(e) => setallowfit(e.target.value + "")}
                                >
                                  <MenuItem key="Fit to window" value="Fit to window">
                                    Fit to window
                                  </MenuItem>
                                  <MenuItem key="Fit to contents" value="Fit to contents">
                                    Fit to contents
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </Grid>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TabPanel>
              </TabContext>
            ) : (
              <Typography sx={{ fontSize: 11, fontStyle: "italic", alignContent: "center" }}>
                Please select fields to display properties...
              </Typography>
            )}
          </Card>
        </Grid>
      </Grid>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isloading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={popupopen} autoHideDuration={6000} onClose={handlepopupClose}>
        <Alert onClose={handlepopupClose} severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Controlpanel;
